module.exports = __webpack_public_path__ + "img/wechat_menu_top.e28902a8.png";